import { parse as cookieParse } from "cookie";

/** Parses the current token from the document cookies. */
export const getSessionToken = (): string | undefined => {
  const { userSession } = cookieParse(document.cookie);
  return typeof userSession === "string" && userSession.length > 0
    ? userSession
    : undefined;
};
